import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { JSX } from 'react/jsx-runtime';

import { hsaContributionsIntial } from 'enrollment/services';
import { DONT_CONTRIBUTE, FIXED } from '../../utils';
import { FixedContributionEr } from './EmployerFixedContribution';
import { DontContributeER } from './EmployerDoNotContribute';

export function EmployerContribution(props: any) {
  const newHSAData = useSelector(hsaContributionsIntial);
  const { t } = useTranslation('pages.financial');
  const employerContribution = newHSAData.employer_contribution_details;
  const currentPlanYear = newHSAData.current_plan_year;
  const containerClassName = 'd-flex justify-content-between';
  const contributionAdjustments = props.contributionAdjustments;
  
  return (
    <div className="px-3_5 px-md-5 pb-3" data-testid="employer-contribution-card">
      {employerContribution.fsa_match_method === FIXED && (
        <FixedContributionEr contributionAdjustments={contributionAdjustments}/>
      )}
      {employerContribution.fsa_match_method === DONT_CONTRIBUTE && (
        <DontContributeER/>
      )}
    </div>
  );
}
